/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_SkuInputs */

const vi_packaging_material_sku = /** @type {(inputs: Packaging_Material_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã SKU`)
};

/**

* @param {Packaging_Material_SkuInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_sku = /** @type {((inputs?: Packaging_Material_SkuInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_SkuInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_sku(inputs)
});